function ValidationErrorDiv({
  errors = {},
  errorKey,
  textCenter = false,
  keySubstitute = null,
}) {
  if (!errors || !errors[errorKey]) {
    return null;
  }

  return (
    <>
      {errors[errorKey].map((error, index) => {
        return (
          <div
            key={index}
            className={
              "theme-text-danger text-xs " + (textCenter ? "text-center" : "")
            }>
            {keySubstitute
              ? error.replace("The " + errorKey, keySubstitute)
              : error}
          </div>
        );
      })}
    </>
  );
}

export { ValidationErrorDiv };
